/* PODbySoni header tools and Saved drawer. Loaded from sections/pbs-marquee.liquid,
   which is in header-group and therefore on every page.

   WHAT THIS DOES
   Also owns the Saved drawer (#pbs-saved, window.pbsSavedDrawer) and every
   Saved count/aria-label. Adds the prototype's three top-right controls to Dawn's header: "Find your
   people", "Saved" with a count, and "Bag" with a count. Dawn ships search,
   account and cart icons; the prototype has labelled buttons. This injects the
   two that do not exist and adds a labelled Bag beside them.

   WHY IT IS INJECTED RATHER THAN WRITTEN INTO header.liquid
   Dawn's header.liquid is 22 KB and the Admin API can only replace whole files.
   Regenerating 22 KB to add three buttons is the single operation most likely to
   corrupt the theme silently. This file is 6 KB and does the same job. If anyone
   ever hand-edits header.liquid, move the markup across and delete this file
   rather than leaving both.

   WHY IT DOES NOT TOUCH podbysoni-brand.js
   That file already owns the save store (localStorage key `pbs_saved`, an array
   of product ids) and repaints every [data-pbs-heart]. This file listens to the
   same clicks and only records the extra thing the drawer needs: the product
   HANDLE, so it can fetch each row from the Section Rendering API,
   /products/<handle>?section_id=pbs-saved-item (sections/pbs-saved-item.liquid),
   on phone and desktop alike. A 404 there means the product is gone, and its id
   is dropped from the store through window.pbsSaved.remove (brand.js).
   Handles are read from the DOM at save time, so neither the product card nor
   the product page needed a markup change for this.

   WARNING, the same one as brand.js: do NOT add a MutationObserver. Rendering
   the header writes to the DOM, the observer re-triggers itself, and the page
   locks up hard. Re-init only on explicit events. */
(function () {
  var KEY = 'pbs_saved';
  var HANDLE_KEY = 'pbs_saved_handles';

  function readIds() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }

  function readHandles() {
    try { return JSON.parse(localStorage.getItem(HANDLE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function writeHandles(map) {
    try { localStorage.setItem(HANDLE_KEY, JSON.stringify(map)); } catch (e) {}
  }

  /* ---------- record the handle whenever something is hearted ----------
     brand.js has its own click listener that writes the id. Both run. This one
     only needs to work out which product the heart belongs to: on a product
     page that is the URL, on a card it is the nearest product link. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-pbs-heart]');
    if (!btn) return;

    var id = btn.dataset.pbsHeart;
    var handle = null;
    var path = null;

    var card = btn.closest('[data-pbs-card], .card-wrapper, .grid__item');
    var link = card ? card.querySelector('a[href*="/products/"]') : null;
    if (link) { path = link.pathname; }
    else if (window.location.pathname.indexOf('/products/') > -1) { path = window.location.pathname; }

    if (path) {
      var m = path.match(/\/products\/([^/?#]+)/);
      if (m) handle = m[1];
    }

    if (!handle) return;
    var map = readHandles();
    map[id] = handle;
    writeHandles(map);
  });

  /* ---------- header controls ---------- */
  function countLabel(text, n) {
    return text + '<span class="pbs-htool__cnt">' + n + '</span>';
  }

  function buildTools() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('[data-pbs-htools]')) return;

    var wrap = document.createElement('div');
    wrap.className = 'pbs-htools';
    wrap.setAttribute('data-pbs-htools', '');

    var quiz = document.createElement('button');
    quiz.type = 'button';
    quiz.className = 'pbs-htool';
    quiz.setAttribute('data-pbs-quiz', '');
    quiz.textContent = 'Find your people';

    var saved = document.createElement('button');
    saved.type = 'button';
    saved.className = 'pbs-htool';
    saved.setAttribute('data-pbs-open-saved', '');
    saved.innerHTML = countLabel('Saved', savedEntries().length);

    var bag = document.createElement('a');
    bag.className = 'pbs-htool';
    bag.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    bag.setAttribute('data-pbs-bag', '');
    bag.innerHTML = countLabel('Bag', 0);

    /* Dawn's own cart icon opens the drawer. Clicking our Bag label should do
       the same thing rather than navigating away from the page. */
    bag.addEventListener('click', function (ev) {
      var icon = document.getElementById('cart-icon-bubble');
      if (icon && document.querySelector('cart-drawer')) {
        ev.preventDefault();
        icon.click();
      }
    });

    wrap.appendChild(quiz);
    wrap.appendChild(saved);
    wrap.appendChild(bag);
    icons.insertBefore(wrap, icons.firstChild);

    refreshCounts();
  }

  /* ---------- helpers ---------- */
  function isPhone() {
    try {
      if (window.PBSPhone && typeof PBSPhone.isPhone === 'function') return !!PBSPhone.isPhone();
      return !!(window.matchMedia && matchMedia('(max-width: 749px)').matches);
    } catch (e) { return false; }
  }

  function reducedMotion() {
    try { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
    catch (e) { return false; }
  }

  /* Saved ids that have a handle. This is the number the list can actually
     show, so it is the number every count uses. */
  function savedEntries() {
    var map = readHandles();
    var out = [];
    readIds().forEach(function (id) {
      id = String(id);
      if (map[id]) out.push({ id: id, handle: map[id] });
    });
    return out;
  }

  function setAttr(el, name, val) {
    try { el.setAttribute(name, val); } catch (e) {}
  }

  /* ---------- counts ---------- */
  function refreshSavedCounts() {
    var n = savedEntries().length;

    var pills = document.querySelectorAll('[data-pbs-saved-count]');
    for (var i = 0; i < pills.length; i++) {
      pills[i].textContent = n;
      setAttr(pills[i], 'data-n', n);
    }

    var cnts = document.querySelectorAll('[data-pbs-open-saved] .pbs-htool__cnt');
    for (var j = 0; j < cnts.length; j++) {
      cnts[j].textContent = n;
      setAttr(cnts[j], 'data-n', n);
      cnts[j].style.display = n ? '' : 'none';
    }

    var label = n === 0 ? 'Saved' : (n === 1 ? 'Saved, 1 item' : 'Saved, ' + n + ' items');
    var openers = document.querySelectorAll('[data-pbs-open-saved]');
    for (var k = 0; k < openers.length; k++) setAttr(openers[k], 'aria-label', label);

    var ph = document.querySelectorAll('.pbs-saved__n--ph');
    for (var p = 0; p < ph.length; p++) ph[p].textContent = n ? '(' + n + ')' : '';
    var dt = document.querySelectorAll('.pbs-saved__n--dt');
    for (var d = 0; d < dt.length; d++) dt[d].textContent = '(' + n + ')';
  }

  function refreshCounts() {
    refreshSavedCounts();

    var b = document.querySelector('[data-pbs-bag] .pbs-htool__cnt');
    if (!b) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { b.textContent = c.item_count; })
      .catch(function () {});
  }

  /* ---------- saved drawer ---------- */
  var X_SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var HEART_EMPTY = '<svg class="pbs-heart-ico-empty" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  var openerEl = null;     /* the control that opened the drawer, for return focus */
  var closeTimer = null;
  var renderToken = 0;     /* drops the result of a render that was superseded */

  function buildDrawer() {
    if (document.getElementById('pbs-saved')) return;
    var el = document.createElement('div');
    el.id = 'pbs-saved';
    el.className = 'pbs-saved';
    el.hidden = true;
    el.innerHTML =
      '<div class="pbs-saved__panel" role="dialog" aria-modal="true" aria-labelledby="pbs-saved-title">' +
      '<div class="pbs-saved__hd"><h2 id="pbs-saved-title">Saved ' +
      '<span class="pbs-saved__n pbs-saved__n--ph medium-hide large-up-hide"></span>' +
      '<span class="pbs-saved__n pbs-saved__n--dt small-hide"></span></h2>' +
      '<button type="button" class="pbs-saved__x" data-pbs-close-saved aria-label="Close saved">' +
      '<span class="pbs-saved__x-ico medium-hide large-up-hide">' + X_SVG + '</span>' +
      '<span class="pbs-saved__x-times small-hide" aria-hidden="true">&times;</span></button></div>' +
      '<div class="pbs-saved__note"><span class="medium-hide large-up-hide">Saved on this phone, ready when you are.</span>' +
      '<span class="small-hide">Saved on this device, ready when you are.</span></div>' +
      '<div class="pbs-saved__body" data-pbs-saved-body></div></div>';
    document.body.appendChild(el);
    refreshSavedCounts();
  }

  function setNoteHidden(hide) {
    var note = document.querySelector('#pbs-saved .pbs-saved__note');
    if (!note) return;
    if (hide) note.setAttribute('hidden', ''); else note.removeAttribute('hidden');
  }

  var EMPTY_HTML =
    '<div class="pbs-saved__empty"><div class="pbs-saved__disc">' + HEART_EMPTY + '</div>' +
    '<h4 class="pbs-saved__empty-h medium-hide large-up-hide">Nothing saved yet</h4>' +
    '<p class="pbs-saved__empty-p"><span class="medium-hide large-up-hide">Tap the heart on anything you love and it waits here.</span>' +
    '<span class="small-hide">Nothing saved yet. Tap the heart on anything you are thinking about.</span></p>' +
    '<a class="button button--secondary pbs-saved__browse medium-hide large-up-hide" href="/collections/best-sellers">Browse Best Sellers</a>' +
    '<button type="button" class="button button--secondary pbs-saved__keep small-hide" data-pbs-close-saved>Keep shopping</button></div>';

  var LOADING_HTML = '<p class="pbs-saved__loading">Loading&hellip;</p>';
  var ERROR_HTML = '<p class="pbs-saved__error">We could not load your saved designs. Check your connection and open Saved again.</p>';

  /* Take the inner HTML of the rendered section (fallback: body). */
  function sectionInner(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var sec = doc.querySelector('.shopify-section') || doc.body;
    return sec ? sec.innerHTML : '';
  }

  /* One row. Resolves { id, state: 'ok' | 'gone' | 'fail', html }. Never rejects. */
  function fetchRow(entry) {
    return fetch('/products/' + encodeURIComponent(entry.handle) + '?section_id=pbs-saved-item')
      .then(function (r) {
        if (r.status === 404) return { id: entry.id, state: 'gone' };
        if (!r.ok) return { id: entry.id, state: 'fail' };
        return r.text().then(function (t) {
          var html = sectionInner(t);
          return html ? { id: entry.id, state: 'ok', html: html } : { id: entry.id, state: 'fail' };
        });
      })
      .catch(function () { return { id: entry.id, state: 'fail' }; });
  }

  /* A product that is gone (404) stops counting. Network failures never do this. */
  function pruneGone(ids) {
    if (!ids.length) return;
    ids.forEach(function (id) {
      if (window.pbsSaved && typeof window.pbsSaved.remove === 'function') window.pbsSaved.remove(id);
    });
    var map = readHandles();
    ids.forEach(function (id) { delete map[id]; });
    writeHandles(map);
  }

  function renderSaved() {
    var body = document.querySelector('[data-pbs-saved-body]');
    if (!body) return;

    var token = ++renderToken;
    var entries = savedEntries();

    if (!entries.length) {
      body.innerHTML = EMPTY_HTML;
      setNoteHidden(isPhone());
      return;
    }

    setNoteHidden(false);
    body.innerHTML = LOADING_HTML;

    Promise.all(entries.map(fetchRow)).then(function (results) {
      if (token !== renderToken) return;

      var gone = [], ok = 0, failed = 0;
      var byId = {};
      results.forEach(function (r) {
        if (r.state === 'gone') gone.push(r.id);
        else if (r.state === 'ok') { ok++; byId[r.id] = r.html; }
        else failed++;
      });
      pruneGone(gone);
      refreshSavedCounts();

      if (!ok && failed) {
        body.innerHTML = ERROR_HTML;
        setNoteHidden(false);
        return;
      }
      if (!ok) {
        body.innerHTML = EMPTY_HTML;
        setNoteHidden(isPhone());
        return;
      }

      /* readIds() order is save order; entries already follows it. */
      var rows = '';
      entries.forEach(function (en) { if (byId[en.id]) rows += byId[en.id]; });
      body.innerHTML = '<div class="pbs-saved__list">' + rows + '</div>';
      setNoteHidden(false);
    });
  }

  function isOpen() {
    var el = document.getElementById('pbs-saved');
    return !!(el && el.classList.contains('is-open'));
  }

  function openSaved(opener) {
    buildDrawer();
    var el = document.getElementById('pbs-saved');
    if (!el) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (opener && opener.nodeType === 1) openerEl = opener;

    /* Overlays do not stack: the bag closes when Saved opens. */
    try {
      var cd = document.querySelector('cart-drawer');
      if (cd && cd.classList.contains('active') && typeof cd.close === 'function') cd.close();
    } catch (err) {}

    refreshSavedCounts();
    renderSaved();

    el.hidden = false;
    void el.offsetWidth;   /* lay the panel out off-screen before the class that slides it in */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    });
    document.documentElement.style.overflow = 'hidden';

    var panel = el.querySelector('.pbs-saved__panel');
    var x = el.querySelector('[data-pbs-close-saved]');
    try { if (typeof trapFocus === 'function' && panel) trapFocus(panel, x || panel); } catch (err2) {}
  }

  /* opts.handoff: Add to bag. Quick add is about to open and owns the scroll
     lock and the focus from here, so do not unlock the page or move focus. */
  function closeSaved(opts) {
    var el = document.getElementById('pbs-saved');
    if (!el || (el.hidden && !el.classList.contains('is-open'))) return;
    var handoff = !!(opts && opts.handoff);

    el.classList.remove('is-open');
    renderToken++;   /* a render still in flight must not write into a closed drawer */

    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    var panel = el.querySelector('.pbs-saved__panel');
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (panel) panel.removeEventListener('transitionend', onEnd);
      if (el.classList.contains('is-open')) return;   /* reopened meanwhile */
      el.hidden = true;
      if (!handoff) document.documentElement.style.overflow = '';
    }
    function onEnd(ev) { if (ev.target === panel) finish(); }

    if (!handoff) {
      try { if (typeof removeTrapFocus === 'function') removeTrapFocus(openerEl); } catch (err) {}
      try { if (openerEl && openerEl.focus) openerEl.focus(); } catch (err2) {}
    }

    if (reducedMotion() || !panel) { finish(); return; }
    panel.addEventListener('transitionend', onEnd);
    closeTimer = setTimeout(finish, 700);
  }

  window.pbsSavedDrawer = { open: openSaved, close: closeSaved };

  function unsave(btn) {
    var row = btn.closest('[data-pbs-sv-id]');
    var id = btn.getAttribute('data-pbs-unsave') || (row && row.getAttribute('data-pbs-sv-id'));
    if (!id) return;
    id = String(id);

    function done() {
      if (window.pbsSaved && typeof window.pbsSaved.remove === 'function') window.pbsSaved.remove(id);
      refreshCounts();
      renderSaved();
      if (window.pbsToast) window.pbsToast('Removed from saved');
    }

    if (isPhone() && row) {
      row.classList.add('pbs-out');
      setTimeout(done, reducedMotion() ? 0 : 230);
    } else {
      done();
    }
  }

  /* Add to bag: close Saved first, but let the click carry on so Quick add's
     own delegated opener still sees it. Capture phase, no preventDefault, no
     stopPropagation. The row stays in the DOM (the quick-add drawer lives in it
     until Quick add moves it to <body> and back). */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('#pbs-saved a[data-pbs-qa-open]')) closeSaved({ handoff: true });
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var opener = e.target.closest('[data-pbs-open-saved]');
    if (opener) { e.preventDefault(); openSaved(opener); return; }
    if (e.target.closest('[data-pbs-close-saved]')) { e.preventDefault(); closeSaved(); return; }

    var root = document.getElementById('pbs-saved');
    if (root && e.target === root) { closeSaved(); return; }

    var un = e.target.closest('#pbs-saved [data-pbs-unsave]');
    if (un) { e.preventDefault(); unsave(un); return; }

    /* Any heart click changes the count, and while the drawer is open it also
       changes the list. brand.js has already written the store by the time this
       runs. */
    if (e.target.closest('[data-pbs-heart]')) {
      setTimeout(function () {
        refreshCounts();
        if (isOpen()) renderSaved();
      }, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closeSaved();
  });

  function init() {
    buildTools();
    buildDrawer();
    refreshCounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { init(); });

  /* Dawn updates the cart drawer without firing an event we can hook. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[name="add"], .cart-remove-button, .quantity__button')) {
      setTimeout(refreshCounts, 400);
      setTimeout(refreshCounts, 1300);
    }
  });
})();
